import { Button } from '@workspace/ui/components/button';

import type { IconComponent } from './auth-aroviders';

type AuthProviderButtonProps = {
  Icon: IconComponent;
} & React.ComponentProps<'button'>;

export function AuthProviderButton({
  Icon,
  ...props
}: AuthProviderButtonProps) {
  return (
    <Button
      type="submit"
      variant="default"
      className="w-12 h-12 flex items-center justify-center [&_svg]:!size-5"
      {...props}
    >
      <Icon />
    </Button>
  );
}
